export default __webpack_public_path__ + "static/media/mic_off.ce0d6152.svg";